import { connect } from 'react-redux';
import { actions as stripeActions } from '~/stripe';

import StripeCreditCardForm from './components/CreditCardForm';

export default connect(
  (state) => ({
    stripePublishableKey: state.creditCardForm.stripePublishableKey,
  }),
  (dispatch) => ({
    createSetupIntentRequest: () =>
      dispatch(stripeActions.createSetupIntentRequest()),
  })
)(StripeCreditCardForm);

export { default as reducer } from './reducer';
